
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/finances/funding-requests",
      function () {
        return require("private-next-pages/[company]/finances/funding-requests/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/finances/funding-requests"])
      });
    }
  